module.exports = __webpack_public_path__ + "static/media/pla_pum_con.e5fb0e87.png";